module.exports = __webpack_public_path__ + "static/media/ww_teli2.e69f6004.gif";